var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285 409 c-4 -5 0 -18 9 -28 14 -16 14 -19 0 -33 -24 -24 -8 -38 42 -38 l44 0 0 -125 c0 -104 2 -125 15 -125 13 0 15 25 15 168 0 117 -4 172 -12 180 -15 15 -104 16 -113 1z m95 -44 c0 -17 -5 -25 -17 -25 -12 0 -18 8 -18 25 0 17 6 25 18 25 12 0 17 -8 17 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 335 c0 -10 10 -15 27 -15 26 0 24 -4 -40 -68 -37 -37 -67 -73 -67 -80 0 -26 27 -10 92 55 64 64 68 66 68 40 0 -17 5 -27 15 -27 12 0 15 13 15 55 l0 55 -55 0 c-42 0 -55 -3 -55 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 155 c0 -78 3 -95 15 -95 12 0 15 17 15 95 0 78 -3 95 -15 95 -12 0 -15 -17 -15 -95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 130 c0 -56 3 -70 15 -70 12 0 15 14 15 70 0 56 -3 70 -15 70 -12 0 -15 -14 -15 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 105 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45 -11 0 -15 -12 -15 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 80 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20 -8 0 -15 -9 -15 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.f3c96be65e01316d61ce2a561d298ca8.svg";
export { ForwardRef as ReactComponent };